module.exports = __webpack_public_path__ + "static/media/icPromptMTD.4fa393b7.svg";